import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { BreadcrumbService } from '../../../domain/services/breadcrumb/breadcrumb.service';
import { DialogService } from '../../../domain/services/dialog/dialog.service';
import { AppraiserOfficeService } from '../../../domain/services/appraiser-office/appraiser-office.service';
import { AppraiserOfficeModel } from '../../../domain/models/appraiser-office.model';

@Component({
  selector: 'app-appraiser-offices',
  standalone: true,
  imports: [CommonModule, MatTableModule, MatButtonModule, MatIconModule],
  templateUrl: './appraiser-offices.component.html',
  styleUrl: './appraiser-offices.component.css',
})
export class AppraiserOfficesComponent implements OnInit {
  displayedColumns = ['name', 'county', 'officeNumber', 'active', 'actions'];
  dataSource = new MatTableDataSource<AppraiserOfficeModel>([]);

  constructor(
    private readonly breadcrumbService: BreadcrumbService,
    private readonly service: AppraiserOfficeService,
    private readonly dialogService: DialogService,
    private readonly router: Router
  ) {}

  ngOnInit(): void {
    this.breadcrumbService.updateBreadcrumbs([
      { icon: 'account_balance', url: '/app/admin/appraiser-offices', label: 'Administrative' },
      { icon: 'apartment', url: '/app/admin/appraiser-offices', label: 'Appraiser offices' },
    ]);
    this.load();
  }

  load(): void {
    this.service.getAll().subscribe((offices) => (this.dataSource.data = offices));
  }

  onAdd(): void {
    this.router.navigate(['/app/admin/appraiser-offices/new']);
  }

  onEdit(row: AppraiserOfficeModel): void {
    this.router.navigate(['/app/admin/appraiser-offices', row.id]);
  }

  onDelete(row: AppraiserOfficeModel): void {
    this.dialogService.openDeletedDialog(
      'Delete Appraiser Office',
      `Are you sure you want to delete "${row.name}"?`,
      (confirmed: boolean) => {
        if (confirmed) {
          this.service.delete(row.id).subscribe(() => this.load());
        }
      }
    );
  }

  goBack(): void {
    window.history.back();
  }
}
